import React, { useCallback, useEffect, useState } from "react";
import api from "../../util/panelApi";
import { PageHead, Tiles, Table, Tabs, Chip, Modal, Person, fmt, when } from "./kit";

// Hesaplar: kime ne odenecek, hediye hareketleri, kisi hesabi (uygulamadaki
// yayinci / ajans / BD ekranlarinin birebir verisi).
const usd = (n) => `${(Number(n) || 0).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} $`;
const TUR = { voice: "Sesli", live: "Görüntülü", call: "Arama" };
const TX = {
  host: "Yayıncı maaşı", hostBonus: "Yayıncı bonusu", hostLevelBonus: "Seviye bonusu", hostUpgradeBonus: "Yükseltme bonusu",
  agency: "Ajans payı", agencyBonus: "Ajans bonusu", daily: "Günlük ödül", newHost: "Yeni yayıncı", gamePromo: "Oyun tanıtımı",
  withdraw: "Çekim", refund: "İade", admin: "Yönetim",
};

const Bar = ({ v, max, ok }) => {
  const p = max ? Math.min(100, Math.round((v / max) * 100)) : 0;
  return (
    <div style={{ height: 6, background: "#E5E7EB", borderRadius: 3, overflow: "hidden", minWidth: 80 }}>
      <div style={{ width: `${p}%`, height: "100%", background: ok ? "#10B981" : "#6366F1" }} />
    </div>
  );
};

// yayincinin uygulamada gordugu hedef karti
const Hedef = ({ kind, h }) => {
  if (!h) return null;
  const saat = Math.floor((h.minutes || 0) / 60);
  return (
    <div style={{ fontSize: 12, marginBottom: 4 }}>
      <b>{TUR[kind]}</b> · Sv {h.level}/{h.levelCount} · {fmt(h.coins)}
      {h.nextTarget ? <> / {fmt(h.nextTarget)} → {usd(h.nextSalaryUsd)}</> : " (en üst)"}
      <Bar v={h.coins} max={h.nextTarget || h.coins} ok={!h.nextTarget} />
      <span style={{ color: h.ok ? "#059669" : "#B45309" }}>
        Gün {h.validDays}/{h.needDays} · Saat {saat}/{h.needHours}
      </span>
    </div>
  );
};

const Ledger = ({ openPerson }) => {
  const [back, setBack] = useState(0);
  const [d, setD] = useState(null);
  const [q, setQ] = useState("");
  const [sahipGizle, setSahipGizle] = useState(true);
  const [sadece, setSadece] = useState(false);
  const [pay, setPay] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    const r = await api.ledger({ back });
    if (r?.status) setD(r);
    setLoading(false);
  }, [back]);
  useEffect(() => { load(); }, [load]);

  const rows = (d?.rows || []).filter((r) =>
    (!sahipGizle || !r.sahip) &&
    (!sadece || r.odenecekUsd > 0 || r.talep) &&
    (!q || `${r.name} ${r.uniqueID} ${r.ajansAdi}`.toLowerCase().includes(q.toLowerCase()))
  );

  const odendi = async (r) => {
    if (r.talep) {
      if (!window.confirm(`${r.name} (${r.uniqueID}) talebi ${usd(r.talep.usd)} ödendi olarak işaretlensin mi?`)) return;
      const x = await api.salaryWithdrawAction(r.talep.id, { action: "paid" });
      window.alert(x?.message || "Tamam");
      load();
    } else setPay({ ...r, usd: r.cekilebilirUsd, note: "" });
  };

  const t = d?.toplam || {};
  return (
    <>
      <div className="d-flex align-items-center" style={{ gap: 8, marginBottom: 10, flexWrap: "wrap" }}>
        <select className="form-control form-control-sm" style={{ width: 220 }} value={back} onChange={(e) => setBack(Number(e.target.value))}>
          <option value={0}>Bu dönem</option>
          <option value={1}>Önceki dönem</option>
          <option value={2}>2 dönem önce</option>
          <option value={3}>3 dönem önce</option>
        </select>
        <b>{d?.donem}</b>
        <input className="form-control form-control-sm" style={{ width: 220 }} placeholder="Ad, ID ya da ajans ara" value={q} onChange={(e) => setQ(e.target.value)} />
        <label style={{ fontSize: 13 }}><input type="checkbox" checked={sahipGizle} onChange={(e) => setSahipGizle(e.target.checked)} /> Sahip/test hesaplarını gizle</label>
        <label style={{ fontSize: 13 }}><input type="checkbox" checked={sadece} onChange={(e) => setSadece(e.target.checked)} /> Yalnız ödenecekler</label>
      </div>
      <Tiles
        items={[
          { label: "Şimdi ödenecek", value: usd(t.odenecek) },
          { label: "Bekleyen talep", value: fmt(t.talep) },
          { label: "Kilitli (süresi dolmamış)", value: usd(t.kilitli) },
          { label: "Bu dönem yayıncı maaşı", value: usd(t.maas) },
          { label: "Bu dönem ajans payı", value: usd(t.ajans) },
        ]}
      />
      <Table
        loading={loading}
        head={["Kişi", "Hedefler (uygulamadaki gibi)", "Bu dönem kazanç", "Cüzdan", "Çekim talebi", "Ödenecek", ""]}
        rows={rows.map((r) => (
          <tr key={r.accountId}>
            <td>
              <Person image={r.image} name={r.name || "—"} />
              <div style={{ fontSize: 11, color: "#6B7280" }}>
                ID {r.uniqueID} {r.ajansAdi ? <>· ajans sahibi: <b>{r.ajansAdi}</b></> : null} {r.sahip ? <Chip kind="wait">sahip</Chip> : null}
              </div>
              <div style={{ fontSize: 11, color: "#6B7280" }}>Coin {fmt(r.coin)} · Elmas {fmt(r.diamond)}</div>
            </td>
            <td style={{ minWidth: 220 }}>
              {Object.keys(TUR).map((k) => <Hedef key={k} kind={k} h={r.hedef?.[k]} />)}
              {!Object.keys(r.hedef || {}).length && <span style={{ color: "#9CA3AF", fontSize: 12 }}>Bu dönem kayıt yok</span>}
            </td>
            <td>
              <div>Maaş {usd(r.maasUsd)}</div>
              {r.ajansUsd ? <div>Ajans {usd(r.ajansUsd)}</div> : null}
            </td>
            <td>
              <div><b>{usd(r.cuzdanUsd)}</b></div>
              <div style={{ fontSize: 11, color: "#059669" }}>çekilebilir {usd(r.cekilebilirUsd)}</div>
              {r.kilitliUsd ? <div style={{ fontSize: 11, color: "#B45309" }}>kilitli {usd(r.kilitliUsd)}</div> : null}
            </td>
            <td style={{ fontSize: 12, maxWidth: 200 }}>
              {r.talep ? (
                <>
                  <b>{usd(r.talep.usd)}</b> · {r.talep.method}
                  <div style={{ wordBreak: "break-all" }}>{r.talep.details}</div>
                  <div style={{ color: "#6B7280" }}>{when(r.talep.at)}</div>
                </>
              ) : "—"}
            </td>
            <td><b style={{ color: r.odenecekUsd > 0 ? "#059669" : "#9CA3AF" }}>{usd(r.odenecekUsd)}</b></td>
            <td style={{ whiteSpace: "nowrap" }}>
              <button className="btn btn-sm btn-outline-primary" onClick={() => openPerson(r.uniqueID)}>Hesabı aç</button>{" "}
              {(r.talep || r.cekilebilirUsd > 0) && <button className="btn btn-sm btn-success" onClick={() => odendi(r)}>Ödendi</button>}
            </td>
          </tr>
        ))}
      />
      <Modal open={!!pay} title={`Elle ödeme · ${pay?.name || ""} (${pay?.uniqueID || ""})`} onClose={() => setPay(null)}>
        {pay && (
          <>
            <div style={{ marginBottom: 8 }}>Çekilebilir: <b>{usd(pay.cekilebilirUsd)}</b>. Ödediğin tutar cüzdandan düşülür ve kişinin çekim geçmişine "Elle ödeme" olarak yazılır.</div>
            <input className="form-control mb-2" type="number" step="0.01" value={pay.usd} onChange={(e) => setPay({ ...pay, usd: e.target.value })} />
            <input className="form-control mb-2" placeholder="Not (ör. IBAN / Binance / tarih)" value={pay.note} onChange={(e) => setPay({ ...pay, note: e.target.value })} />
            <button
              className="btn btn-success"
              onClick={async () => {
                const x = await api.ledgerPay({ accountId: pay.accountId, usd: Number(pay.usd), note: pay.note });
                window.alert(x?.message || "Tamam");
                if (x?.status) { setPay(null); load(); }
              }}
            >
              Ödendi olarak kaydet
            </button>
          </>
        )}
      </Modal>
    </>
  );
};

const GiftFlow = ({ openPerson }) => {
  const [f, setF] = useState({ days: 7, id: "", hostToHost: "1" });
  const [d, setD] = useState(null);
  const [loading, setLoading] = useState(true);
  const load = useCallback(async () => {
    setLoading(true);
    const r = await api.giftFlow(f);
    setD(r);
    setLoading(false);
  }, [f]);
  useEffect(() => { load(); }, [load]);
  const K = ({ k }) => (
    <div style={{ cursor: "pointer" }} onClick={() => k.uniqueID && openPerson(k.uniqueID)}>
      <Person image={k.image} name={k.name || "—"} />
      <div style={{ fontSize: 11, color: "#6B7280" }}>ID {k.uniqueID} {k.host ? <Chip kind="info">yayıncı</Chip> : <Chip kind="wait">kullanıcı</Chip>}</div>
    </div>
  );
  const [idText, setIdText] = useState("");
  return (
    <>
      <div className="d-flex align-items-center" style={{ gap: 8, marginBottom: 10, flexWrap: "wrap" }}>
        <select className="form-control form-control-sm" style={{ width: 140 }} value={f.days} onChange={(e) => setF({ ...f, days: Number(e.target.value) })}>
          {[1, 3, 7, 15, 30, 60, 90].map((g) => <option key={g} value={g}>Son {g} gün</option>)}
        </select>
        <select className="form-control form-control-sm" style={{ width: 230 }} value={f.hostToHost} onChange={(e) => setF({ ...f, hostToHost: e.target.value })}>
          <option value="1">Yalnız yayıncıdan yayıncıya</option>
          <option value="0">Herkes</option>
        </select>
        <input className="form-control form-control-sm" style={{ width: 160 }} placeholder="Kişi ID" value={idText} onChange={(e) => setIdText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && setF({ ...f, id: idText.trim() })} />
        <button className="btn btn-sm btn-primary" onClick={() => setF({ ...f, id: idText.trim() })}>Filtrele</button>
        {f.id && <button className="btn btn-sm btn-link" onClick={() => { setIdText(""); setF({ ...f, id: "" }); }}>temizle</button>}
      </div>
      {d && !d.status && <div className="alert alert-warning">{d.message}</div>}
      <Tiles items={[{ label: "Gösterilen toplam", value: `${fmt(d?.toplam)} coin` }, { label: "Satır", value: fmt(d?.rows?.length) }]} />
      <Table
        loading={loading}
        head={["Gönderen", "", "Alan", "Toplam coin", "Hediye adedi", "Son"]}
        rows={(d?.rows || []).map((r, i) => (
          <tr key={i}>
            <td><K k={r.gonderen} /></td>
            <td style={{ fontSize: 18 }}>→</td>
            <td><K k={r.alan} /></td>
            <td><b>{fmt(r.coin)}</b></td>
            <td>{fmt(r.adet)}</td>
            <td>{when(r.son)}</td>
          </tr>
        ))}
      />
    </>
  );
};

const Kv = ({ items }) => (
  <div className="d-flex" style={{ gap: 10, flexWrap: "wrap", marginBottom: 12 }}>
    {items.map(([k, v]) => (
      <div key={k} style={{ background: "#F3F4F6", borderRadius: 8, padding: "8px 12px", minWidth: 120 }}>
        <div style={{ fontSize: 11, color: "#6B7280" }}>{k}</div>
        <div style={{ fontWeight: 700 }}>{v}</div>
      </div>
    ))}
  </div>
);

const Section = ({ title, children }) => (
  <div className="card mb-3"><div className="card-body"><h5 style={{ marginBottom: 12 }}>{title}</h5>{children}</div></div>
);

const Person360 = ({ id, setId }) => {
  const [text, setText] = useState(id || "");
  const [d, setD] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => { setText(id || ""); }, [id]);
  useEffect(() => {
    if (!id) return;
    setLoading(true);
    api.ledgerPerson(id).then((r) => { setD(r); setLoading(false); });
  }, [id]);
  const m = d?.maasEkrani;
  const ag = d?.ajansEkrani;
  const bd = d?.bdEkrani;
  return (
    <>
      <div className="d-flex" style={{ gap: 8, marginBottom: 12 }}>
        <input className="form-control" style={{ maxWidth: 240 }} placeholder="Kullanıcı ID" value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && setId(text.trim())} />
        <button className="btn btn-primary" onClick={() => setId(text.trim())}>Aç</button>
      </div>
      {loading && <div>Yükleniyor…</div>}
      {d && !d.status && <div className="alert alert-warning">{d.message}</div>}
      {d?.status && !loading && (
        <>
          <Section title={<>{d.kisi.name} <small style={{ color: "#6B7280" }}>ID {d.kisi.uniqueID}</small> {d.kisi.sahip ? <Chip kind="wait">sahip</Chip> : null}</>}>
            <Kv
              items={[
                ["Coin bakiyesi", fmt(d.kisi.coin)],
                ["Elmas", fmt(d.kisi.diamond)],
                ["Maaş cüzdanı", usd(d.cuzdan.usd)],
                ["Çekilebilir", usd(d.cuzdan.cekilebilir)],
                ["Kilitli", usd(d.cuzdan.kilitli)],
                ["Toplam kazandı", usd(d.cuzdan.toplam)],
                ["Toplam çekti", usd(d.cuzdan.cekilen)],
                ["Bağlı ajans", d.bagliAjans ? `${d.bagliAjans.name} (${d.bagliAjans.code})` : "—"],
                ["Sahibi olduğu ajans", d.ajans ? `${d.ajans.name} · ${d.ajans.status}` : "—"],
              ]}
            />
          </Section>

          <Section title="Yayıncı ekranı (uygulamada gördüğü)">
            {!m?.enabled ? <div>Maaş sistemi kapalı.</div> : (
              <>
                <div style={{ fontSize: 12, color: "#6B7280", marginBottom: 8 }}>Ay {m.month} · bekleme {m.policy.holdDays} gün · en az çekim {m.policy.minWithdrawUsd}$</div>
                <div className="row">
                  {Object.keys(TUR).map((k) => {
                    const h = m.host?.[k];
                    const lv = m.policy?.[k]?.levels || [];
                    if (!h) return null;
                    return (
                      <div className="col-md-4" key={k}>
                        <div style={{ border: "1px solid #E5E7EB", borderRadius: 10, padding: 12, marginBottom: 10 }}>
                          <b>{TUR[k]}</b> <small style={{ color: "#6B7280" }}>({h.period === "month" ? "aylık" : h.period === "week" ? "haftalık" : "günlük"})</small>
                          <div style={{ fontSize: 22, fontWeight: 800 }}>{fmt(h.coins)} <small style={{ fontSize: 12 }}>coin</small></div>
                          <div>Seviye <b>{h.level}</b> / {h.levelCount}</div>
                          {h.nextTarget ? <div>Sonraki hedef {fmt(h.nextTarget)} → maaş {usd(h.nextSalaryUsd)}</div> : <div>En üst seviye</div>}
                          <Bar v={h.coins} max={h.nextTarget || h.coins} ok={!h.nextTarget} />
                          <div style={{ marginTop: 6, color: h.ok ? "#059669" : "#B45309" }}>
                            Geçerli gün {h.validDays}/{h.needDays} · Saat {Math.floor(h.minutes / 60)}/{h.needHours} {h.ok ? "✓ şart tamam" : "✗ şart eksik"}
                          </div>
                          <div>Kazandığı: yayıncı {usd(h.hostUsd)} · ajans {usd(h.agencyUsd)}</div>
                          <div>Elmas {fmt(h.earnedDiamond)}</div>
                          {lv.length > 0 && (
                            <details style={{ marginTop: 6 }}>
                              <summary style={{ cursor: "pointer", fontSize: 12 }}>Maaş tablosu</summary>
                              <table className="table table-sm" style={{ fontSize: 11 }}>
                                <thead><tr><th>Sv</th><th>Hedef</th><th>Maaş</th><th>Bonus</th><th>Ajans</th></tr></thead>
                                <tbody>
                                  {lv.map((x, i) => (
                                    <tr key={i} style={{ background: i + 1 === h.level ? "#D1FAE5" : i === h.level ? "#EEF2FF" : undefined }}>
                                      <td>{i + 1}</td><td>{fmt(x.t)}</td><td>{usd(x.h)}</td><td>{usd(x.hb)}</td><td>{usd(x.a)}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </details>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
                {m.calls && <div style={{ fontSize: 13 }}>Görüntülü arama bu ay: {fmt(m.calls.month.calls)} arama · {fmt(m.calls.month.coins)} coin · dakika ücreti {fmt(m.calls.privatePerMin)}</div>}
              </>
            )}
          </Section>

          {(ag || m?.agency) && (
            <Section title="Ajans ekranı (ajans sahibinin gördüğü)">
              {ag && (
                <>
                  <Kv
                    items={[
                      ["Ajans", `${ag.agency?.name} (${ag.agency?.code})`],
                      ["Bugün yayıncı / komisyon", `${fmt(ag.stats.today.host)} / ${fmt(ag.stats.today.commission)}`],
                      ["Bu hafta", `${fmt(ag.stats.week.host)} / ${fmt(ag.stats.week.commission)}`],
                      ["Bu ay", `${fmt(ag.stats.month.host)} / ${fmt(ag.stats.month.commission)}`],
                      ["Bakiye", fmt(ag.agency?.balance)],
                      ["Yayıncı", fmt(ag.members?.length)],
                      ["Bekleyen istek", fmt(ag.pending?.length)],
                    ]}
                  />
                  <table className="table table-sm">
                    <thead><tr><th>Yayıncı</th><th>Durum</th><th>Bu ay kazanç</th><th>Toplam</th><th>Katılma</th></tr></thead>
                    <tbody>
                      {(ag.members || []).map((x) => (
                        <tr key={x._id}>
                          <td><Person image={x.hostImage} name={x.hostName} /></td>
                          <td>{x.isLive ? <Chip>Yayında</Chip> : x.isOnline ? <Chip kind="info">Çevrimiçi</Chip> : "—"}</td>
                          <td>{fmt(x.monthEarn)}</td>
                          <td>{fmt(x.totalEarn)}</td>
                          <td>{when(x.joinedAt)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )}
              {m?.agency && (
                <>
                  <h6>Ajans maaş ekranı · {m.agency.name}</h6>
                  {Object.keys(TUR).map((k) => (m.agency[k] || []).length ? (
                    <div key={k}>
                      <b>{TUR[k]}</b>
                      <table className="table table-sm">
                        <thead><tr><th>Yayıncı</th><th>Coin</th><th>Seviye</th><th>Ajans payı</th></tr></thead>
                        <tbody>
                          {m.agency[k].map((x) => (
                            <tr key={String(x.hostId)}><td><Person image={x.image} name={x.name} /></td><td>{fmt(x.coins)}</td><td>{x.level}</td><td>{usd(x.agencyUsd)}</td></tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : null)}
                </>
              )}
            </Section>
          )}

          {bd && (
            <Section title="BD ekranı (BD'nin gördüğü)">
              <Kv
                items={[
                  ["BD", bd.bd?.name || bd.bd?.code || "—"],
                  ["Komisyon", `%${bd.bd?.commissionPercent || 0}`],
                  ["Bugün", fmt(bd.stats?.today)],
                  ["Bu hafta", fmt(bd.stats?.week)],
                  ["Toplam", fmt(bd.stats?.total)],
                  ["Bakiye", fmt(bd.stats?.balance)],
                  ["Çekilen", fmt(bd.stats?.withdrawn)],
                  ["Bekleyen ödeme", fmt(bd.stats?.pendingPayout)],
                ]}
              />
              <table className="table table-sm">
                <thead><tr><th>Ajans</th><th>Yayıncı</th><th>Yayıncı kazancı</th><th>BD komisyonu</th></tr></thead>
                <tbody>
                  {(bd.agencies || []).map((a) => {
                    const e = (bd.kazanc?.rows || []).find((x) => x.agencyId === String(a._id)) || {};
                    return <tr key={a._id}><td>{a.name} <small>({a.code})</small></td><td>{a.hostCount}</td><td>{fmt(e.hostCoin)}</td><td>{fmt(e.commission)}</td></tr>;
                  })}
                </tbody>
              </table>
            </Section>
          )}

          <div className="row">
            <div className="col-md-6">
              <Section title="Son 30 gün gönderdiği hediyeler">
                <table className="table table-sm"><tbody>
                  {d.gonderdi.map((x) => <tr key={x.id} style={{ cursor: "pointer" }} onClick={() => setId(x.uniqueID)}><td>{x.name} <small>ID {x.uniqueID}</small> {x.host ? <Chip kind="info">yayıncı</Chip> : null}</td><td>{fmt(x.coin)}</td><td>{x.adet} adet</td></tr>)}
                  {!d.gonderdi.length && <tr><td>Yok</td></tr>}
                </tbody></table>
              </Section>
            </div>
            <div className="col-md-6">
              <Section title="Son 30 gün aldığı hediyeler">
                <table className="table table-sm"><tbody>
                  {d.aldi.map((x) => <tr key={x.id} style={{ cursor: "pointer" }} onClick={() => setId(x.uniqueID)}><td>{x.name} <small>ID {x.uniqueID}</small> {x.host ? <Chip kind="info">yayıncı</Chip> : null}</td><td>{fmt(x.coin)}</td><td>{x.adet} adet</td></tr>)}
                  {!d.aldi.length && <tr><td>Yok</td></tr>}
                </tbody></table>
              </Section>
            </div>
          </div>

          <Section title="Cüzdan hareketleri">
            <table className="table table-sm">
              <thead><tr><th>Tarih</th><th>Tür</th><th>Tutar</th><th>Kullanılabilir</th><th>Not</th></tr></thead>
              <tbody>
                {d.txs.map((x) => (
                  <tr key={x._id}>
                    <td>{when(x.createdAt)}</td><td>{TX[x.type] || x.type} {x.kind ? `· ${TUR[x.kind] || x.kind}` : ""} {x.level ? `· sv${x.level}` : ""}</td>
                    <td style={{ color: x.usd < 0 ? "#DC2626" : "#059669" }}>{usd(x.usd)}</td>
                    <td>{x.usd > 0 ? when(x.availableAt) : ""}</td><td style={{ fontSize: 11 }}>{x.note}</td>
                  </tr>
                ))}
                {!d.txs.length && <tr><td colSpan={5}>Hareket yok</td></tr>}
              </tbody>
            </table>
          </Section>

          <Section title="Çekim / ödeme geçmişi">
            <table className="table table-sm">
              <thead><tr><th>Tarih</th><th>Tutar</th><th>Yöntem</th><th>Hesap</th><th>Durum</th></tr></thead>
              <tbody>
                {d.cekimler.map((x) => (
                  <tr key={x._id}><td>{when(x.createdAt)}</td><td>{usd(x.usd)}</td><td>{x.method}</td><td style={{ wordBreak: "break-all" }}>{x.details}</td>
                    <td>{x.status === "paid" ? <Chip>Ödendi</Chip> : x.status === "rejected" ? <Chip kind="bad">Red</Chip> : <Chip kind="wait">Bekliyor</Chip>}</td></tr>
                ))}
                {!d.cekimler.length && <tr><td colSpan={5}>Yok</td></tr>}
              </tbody>
            </table>
          </Section>
        </>
      )}
    </>
  );
};

const Accounts = () => {
  const [tab, setTab] = useState("ledger");
  const [pid, setPid] = useState("");
  const openPerson = (id) => { setPid(String(id || "")); setTab("person"); window.scrollTo(0, 0); };
  return (
    <>
      <PageHead title="Hesaplar" sub="Kime ne ödeyeceğin, kim kime hediye attı ve her yayıncı / ajans / BD'nin uygulamada gördüğü ekranın birebir hali. Dönemler 1-15 ve 16-ay sonu." />
      <Tabs tabs={[["ledger", "Kime ne ödeyeceğim"], ["gifts", "Hediye hareketleri"], ["person", "Kişi hesabı"]]} value={tab} onChange={setTab} />
      {tab === "ledger" && <Ledger openPerson={openPerson} />}
      {tab === "gifts" && <GiftFlow openPerson={openPerson} />}
      {tab === "person" && <Person360 id={pid} setId={setPid} />}
    </>
  );
};

export default Accounts;
